import pRetry from 'p-retry';

export const sleep = time => {
  return new Promise(resolve => {
    setTimeout(resolve, time * 1000);
  });
};

export const readFileAsText = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = e => resolve(e.target.result);
    reader.onerror = e => reject(e.target.error);
    reader.readAsText(file);
  });
};

export const blobToDataURL = blob => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const cleanPhoneNumber = number => number.replace(/[ ()]/g, '');

export const isMobile = () => {
  return (
    window?.ReactNativeWebView !== undefined ||
    !window ||
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator?.userAgent
    )
  );
};

export const genId = () => {
  return new Date().getTime() + '.' + Math.random().toString().slice(2, 8);
};

export const request = async ({
  endpoint,
  body,
  method = 'POST',
  headers = {},
  retries = 5,
  qdelay = 30
}) => {
  const run = async attempt => {
    try {
      const init = {
        headers: {
          'Content-Type': 'application/json',
          ...headers
        },
        method
      };

      if (body !== undefined && method !== 'GET') {
        init.body = JSON.stringify(body);
      }

      const response = await fetch(endpoint, init);

      if (!response.ok) throw new Error(`HTTP status: ${response.status}`);

      const text = await response.text();
      return text ? JSON.parse(text) : null;
    } catch (err) {
      const delay = qdelay * (attempt - 1);
      if (delay) await sleep(delay);
      throw err;
    }
  };

  return await pRetry(run, { retries });
};

/**
 * Cliente HTTP genérico para APIs REST (LorentzServer).
 */
export const apiRequest = async ({
  baseUrl,
  path,
  method = 'GET',
  body,
  token,
  headers = {},
  retries = 3,
  qdelay = 10
}) => {
  const endpoint = `${baseUrl.replace(/\/$/, '')}${path}`;
  const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};

  return request({
    endpoint,
    body,
    method,
    headers: { ...authHeaders, ...headers },
    retries,
    qdelay
  });
};
